import React from 'react';
import { AlertTriangle, ArrowLeft } from 'lucide-react';

const StepPreviewOverlay = ({ stepNumber, stepLabel, onReturn, children }) => {
  return (
    <div className="step-preview-wrapper">
      <div className="step-preview-banner">
        <AlertTriangle size={20} className="step-preview-icon" />
        <div className="step-preview-text">
          <strong>Preview Only — Step {stepNumber}{stepLabel ? `: ${stepLabel}` : ''}</strong>
          <span>You must complete the steps in sequence to unlock editing. Scroll down to browse this step.</span>
        </div>
        <button className="step-preview-return-btn" onClick={onReturn}>
          <ArrowLeft size={16} />
          Return to my progress
        </button>
      </div>
      <div className="step-preview-content">
        {children}
        <div className="step-preview-blocker" aria-hidden="true" />
      </div>
    </div>
  );
};

export default StepPreviewOverlay;
